
    <usb-popup [isLoading]="false" [showAlways]="true">
      <div class="mb-3">
        <img width="40" height="40" src="../../../../assets/icons/LUPA.svg" alt="Spinner" style="transform: scaleX(-1);" />
      </div>
      <h2 class="cancel-loader_title">Verificando</h2>
      <h3 class="cancel-loader_subtitle mb-2">Disponibilidad</h3>
      <p class="cancel-loader_text">Por favor espere mientras obtenemos <br /> las respuestas</p>
    </usb-popup>
  